import React, { useEffect, useState } from "react"
import { ISortStep, IQuery, IQueryBuilderContext, IStepValidationResponse, StepType, IDataSource } from "@types"
import { findSourceById, getSelectedStepDetailsById, handleStepFieldValueChanges, registerStep, validateFieldConfiguration, validateSource, validateStep, validateStepNameAndId } from "@utils"
import { FormSection } from "@components/FormSection/FormSection"
import { SourceSelectorInput } from "../SourceSelector/SourceSelectorInput"
import { updateSource, updateStep } from "../StepConfigUtils"
import { SortEditor, validateSortConditions } from "../Sort/SortEditor"
import Icon from '@images/sort.svg'

export function renderStep(context: IQueryBuilderContext, query: IQuery, onChange: (query: IQuery) => void, selectedStepId: string) {
    const { step, index, previousSteps, selectedSources } = getSelectedStepDetailsById(query, selectedStepId)
    const _step: ISortStep = Object.assign({}, step as ISortStep)

    const [errors, setErrors] = useState<Record<string, string>>({})

    useEffect(() => {
        const { isValid, errors } = validateStep(query, step as ISortStep)
        setErrors(errors)
    }, [step])

    const source = findSourceById(query, _step?.source)

    async function onValueChange(field: string, value: any, source?: boolean) {
        const _query = await handleStepFieldValueChanges(context, query, selectedStepId, field, value, source)
        onChange(_query)
    }

    return <React.Fragment>
        <FormSection
            label='Source'
            error={errors?.source}
        >
            <SourceSelectorInput
                source={source}
                onChange={(newSource) => { onValueChange('source', newSource, true) }}
                availableSources={[...previousSteps, ...selectedSources]}
                query={query}
            />
        </FormSection>

        <FormSection
            label='Sort by'
            error={errors?.attributes}
        >
            <SortEditor
                conditions={_step?.attributes || []}
                onChange={(updated) => onValueChange('attributes', updated)}
                fields={(source as IDataSource)?.schema || []}
            />
        </FormSection>

    </React.Fragment>
}

function validate(query: IQuery, step: ISortStep): IStepValidationResponse {
    const errors: Record<string, string> = validateStepNameAndId(step);
    // validate source
    const source = validateSource(query, step, 'source')
    if (!source.isValid) errors.source = source.error

    const conditions = validateSortConditions(step?.attributes)
    if (conditions.isValid) {
        const fields = validateFieldConfiguration(query, step, conditions.uniqueAttributes, 'source')
        if (!fields.isValid) errors.attributes = fields.error
    }
    else errors.attributes = conditions.error

    return { isValid: Object.keys(errors).length === 0, errors };
}

registerStep({
    type: StepType.Sort,
    name: "Sort",
    description: "Sort data by one or more fields",
    icon: Icon,
    render: renderStep,
    validate: validate,
    onSelectStep: (basicProps, previousSource) => {
        return { ...basicProps, source: previousSource, attributes: [] } as ISortStep
    }
})